// Navaris's verdict on a candidate it has not filed, shown the same on a source's
// Candidates tab and a document type's page, and the order both list candidates in.
import { Sparkles } from 'lucide-react';

export interface Verdict {
    verdict?: 'file' | 'leave' | null;
    verdict_reason?: string | null;
    verdict_type?: string | null;
    verdict_type_name?: string | null;
}

const RANK: Record<string, number> = { file: 0, leave: 2 };

// Recommended first, then those not yet judged, then those Navaris left.
export function byVerdict(a: Verdict, b: Verdict): number {
    return (RANK[a.verdict ?? ''] ?? 1) - (RANK[b.verdict ?? ''] ?? 1);
}

// `typeId` is the type the row is listed under; a verdict for another type names it.
export default function VerdictNote({ verdict, typeId }: { verdict: Verdict; typeId?: string | null }) {
    if (!verdict.verdict) return null;
    const other = verdict.verdict_type && verdict.verdict_type !== typeId
        ? ` as ${verdict.verdict_type_name || verdict.verdict_type}`
        : '';
    const reason = verdict.verdict_reason;
    return (
        <span className="flex items-start gap-1 mt-1 text-xs text-graphite">
            <Sparkles className="w-3 h-3 mt-0.5 shrink-0 text-brand-dark" aria-hidden />
            {verdict.verdict === 'file'
                ? `Navaris recommends filing this${other}.`
                : `Navaris left this unfiled${other}${reason ? `: ${reason}` : '.'}`}
        </span>
    );
}
